import React from 'react';
import { Store, Search, SortAsc } from 'lucide-react';

const ShopPicksFallback: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-950 via-dark-900 to-dark-950 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-neon-green/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Store className="w-8 h-8 text-neon-green" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Shop Picks</h1>
          <p className="text-gray-400">Loading marketplace...</p>
        </div>

        {/* Search and Filters */}
        <div className="mb-8 space-y-4">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-3 w-5 h-5 text-gray-400" />
              <div className="w-full bg-dark-800 border border-gray-700 rounded-xl pl-10 pr-4 py-3 h-12 animate-pulse" />
            </div>
            <div className="flex gap-2">
              <div className="w-32 bg-dark-800 border border-gray-700 rounded-xl h-12 animate-pulse" />
              <div className="w-24 bg-dark-800 border border-gray-700 rounded-xl h-12 animate-pulse flex items-center justify-center">
                <SortAsc className="w-4 h-4 text-gray-400" />
              </div>
            </div>
          </div>
        </div>

        {/* Creator Grid Skeleton */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={index}
              className="bg-dark-900 border border-gray-700 rounded-xl p-6 animate-pulse"
            >
              {/* Avatar */}
              <div className="w-16 h-16 bg-gray-700 rounded-full mx-auto mb-4" />

              {/* Name */}
              <div className="h-4 bg-gray-700 rounded mb-2" />

              {/* Stats */}
              <div className="space-y-2 mb-4">
                <div className="h-3 bg-gray-700 rounded w-3/4" />
                <div className="h-3 bg-gray-700 rounded w-1/2" />
              </div>

              {/* Price */}
              <div className="h-6 bg-gray-700 rounded mb-3" />

              {/* Button */}
              <div className="h-10 bg-gray-700 rounded" />
            </div>
          ))}
        </div>

        {/* Loading message */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-2 text-gray-400">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-neon-green"></div>
            <span>Loading creators...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopPicksFallback;